// src/components/MetronomeLEDs.tsx
import { memo } from 'react';
import '../styles/MetronomeLEDs.css';

interface MetronomeLEDsProps {
  isBeatActive: boolean;
  isDownbeatActive: boolean;
  enabled: boolean;
}

export const MetronomeLEDs = memo(function MetronomeLEDs({
  isBeatActive,
  isDownbeatActive,
  enabled,
}: MetronomeLEDsProps) {
  const disabledClass = enabled ? '' : 'disabled';

  return (
    <div className="metronome-leds" aria-label="Metronome indicators">
      <div
        data-testid="metronome-led-measure"
        className={`metronome-led measure ${isDownbeatActive ? 'active' : ''} ${disabledClass}`}
        aria-label="Measure indicator"
      />
      <div
        data-testid="metronome-led-beat"
        className={`metronome-led beat ${isBeatActive ? 'active' : ''} ${disabledClass}`}
        aria-label="Beat indicator"
      />
    </div>
  );
});
